<form [formGroup]="formGroup">
  <div class="l-header">
    <a [href]="getUrl()">
      <h1 class="l-header__logo">
        <img
          alt="JAPAN PHARMA INC."
          src="./../../../../assets/img/logo.png"
          class="c-pc"
        />
        <img
          alt="JAPAN PHARMA INC."
          src="./../../../../assets/img/logo-sp.png"
          class="c-sp"
        />
      </h1>
    </a>
    <a [href]="getUrl()">
      <h2 class="l-header__title">JAPAN PHARMA INC.</h2>
    </a>
    <div class="l-header__menu">
      <ul class="l-header__list">
        <li>
          <a translate [href]="'/about' + getUrl()">{{ "link.menu.about" }}</a>
        </li>
        <li>
          <a translate [href]="'/service' + getUrl()">{{
            "link.menu.service"
          }}</a>
        </li>
        <!-- <li>
          <a translate [href]="'/management' + getUrl()">{{
            "link.menu.management"
          }}</a>
        </li> -->
        <li>
          <app-selectbox
            *ngIf="arrayPath[3] !== 'complete'"
            label=""
            formControlName="language"
            [options]="languageOption"
            [selected]="formGroup.value.language"
            (change)="changeLanguage()"
          ></app-selectbox>
        </li>
        <li>
          <a [href]="'/contact' + getUrl()"
            ><img
              src="./../../../../assets/img/contact-header.png"
              alt="contact"
          /></a>
        </li>
      </ul>
    </div>

    <div class="l-header__humberge">
      <img
        *ngIf="!isHumberger"
        src="./../../../../assets/img/menu.png"
        alt="メニュー"
        (click)="onHumberger()"
      />
      <img
        *ngIf="isHumberger"
        src="./../../../../assets/img/close.png"
        alt="メニュー"
        (click)="onHumberger()"
      />
    </div>

    <div class="l-header__panel" *ngIf="isHumberger">
      <ul>
        <li
          [ngClass]="{
            '--select': arrayPath[3] === 'about'
          }"
        >
          <a translate [href]="'/about' + getUrl()">{{ "link.menu.about" }}</a>
        </li>
        <li
          [ngClass]="{
            '--select': arrayPath[3] === 'service'
          }"
        >
          <a translate [href]="'/service' + getUrl()">{{
            "link.menu.service"
          }}</a>
        </li>
        <!-- <li
          [ngClass]="{
            '--select': arrayPath[3] === 'management'
          }"
        >
          <a translate [href]="'/management' + getUrl()">{{
            "link.menu.management"
          }}</a>
        </li> -->
        <li
          [ngClass]="{
            '--select': arrayPath[3] === 'contact'
          }"
        >
          <a translate [href]="'/contact' + getUrl()">{{
            "link.menu.contact"
          }}</a>
        </li>
        <li>
          <app-selectbox
            *ngIf="arrayPath[3] !== 'complete'"
            label=""
            formControlName="language"
            [options]="languageOption"
            [selected]="formGroup.value.language"
            (change)="changeLanguage()"
          ></app-selectbox>
        </li>
      </ul>
    </div>
  </div>
</form>
